import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import Image from 'components/FutureImage';

const useStyles = makeStyles()(() => ({
  heading: {
    textShadow: '1px 1px 20px #343A40',
    fontSize: '4em',
  },
}));

export default function ContestJumbotron() {
  const { classes } = useStyles();
  return (
    <div className="tw-relative tw-full tw-h-[500px] tw-flex">
      <Image
        src="https://img.travelfeed.io/bg-003.jpg"
        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABCAIAAAB2XpiaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAFUlEQVR4nGNQZmbI99f9/3plfZIFABkaBL5NOXW3AAAAAElFTkSuQmCC"
        priority
        alt="Travel Blog"
        placeholder="blur"
        sizes="100vw"
        className="tw-object-cover tw-object-center"
        fill
      />
      <div className="my-auto container text-center tw-z-10">
        <Typography
          variant="h2"
          component="h1"
          className={`font-weight-bold text-light ${classes.heading} pb-4`}
        >
          TravelFeed Contests
        </Typography>
        <Typography
          component="h2"
          variant="h6"
          className="font-weight-bold text-light"
        >
          Participate and earn cryptocurrency!
        </Typography>
      </div>
    </div>
  );
}
